var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 26.5859H27.0793",
    stroke: "#14181F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 26.5857H10.4598L26.1 10.9455C26.6409 10.4046 26.6409 9.52773 26.1 8.98686L22.5188 5.40565C21.9779 4.86478 21.101 4.86478 20.5602 5.40565L4.91992 21.0459V26.5857Z",
    fill: "#F7ED90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4598 26.5857V27.0857C10.5924 27.0857 10.7196 27.033 10.8133 26.9393L10.4598 26.5857ZM4.91992 26.5857H4.41992C4.41992 26.8619 4.64378 27.0857 4.91992 27.0857V26.5857ZM4.91992 21.0459L4.56637 20.6923C4.4726 20.7861 4.41992 20.9133 4.41992 21.0459H4.91992ZM20.5602 5.40565L20.9137 5.7592V5.7592L20.5602 5.40565ZM22.5188 5.40565L22.1652 5.7592V5.7592L22.5188 5.40565ZM26.1 8.98686L26.4536 8.63331V8.63331L26.1 8.98686ZM26.1 10.9455L25.7464 10.5919L26.1 10.9455ZM10.4598 26.0857H4.91992V27.0857H10.4598V26.0857ZM5.41992 26.5857V21.0459H4.41992V26.5857H5.41992ZM5.27348 21.3994L20.9137 5.7592L20.2066 5.05209L4.56637 20.6923L5.27348 21.3994ZM22.1652 5.7592L25.7465 9.34042L26.4536 8.63331L22.8723 5.05209L22.1652 5.7592ZM25.7464 10.5919L10.1062 26.2322L10.8133 26.9393L26.4536 11.299L25.7464 10.5919ZM25.7465 9.34042C26.092 9.68602 26.092 10.2463 25.7464 10.5919L26.4536 11.299C27.1897 10.5629 27.1897 9.36943 26.4536 8.63331L25.7465 9.34042ZM20.9137 5.7592C21.2593 5.4136 21.8196 5.4136 22.1652 5.7592L22.8723 5.05209C22.1362 4.31597 20.9427 4.31597 20.2066 5.05209L20.9137 5.7592Z",
    fill: "#14181F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5L16.5 10L21.5 15.5L26.5 10L21.5 5Z",
    fill: "#F7BFCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.9668L21.5398 15.5066",
    stroke: "#14181F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.3665e03ebaaaa98504537c381d31f328.svg";
export { ForwardRef as ReactComponent };